import { render, staticRenderFns } from "./NewParcel.vue?vue&type=template&id=ad577f2a&scoped=true&"
import script from "./NewParcel.vue?vue&type=script&lang=ts&"
export * from "./NewParcel.vue?vue&type=script&lang=ts&"
import style0 from "./NewParcel.vue?vue&type=style&index=0&id=ad577f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad577f2a",
  null
  
)

export default component.exports